/**
 * pasteDedentExtension — CodeMirror extension that strips the common
 * leading whitespace from multi-line clipboard content before it lands
 * in the editor.
 *
 * sl-93dd.2: Removes the single most common Python IndentationError
 * source — pasting code from Markdown or chat with a shared 2/4-space
 * prefix. Delegates to `dedentCode` from sl-93dd.1, so the save-time
 * normalizer and the manual Format button share the same semantics.
 *
 * Single-line pastes and pastes whose content does not need dedenting
 * are forwarded unchanged so plain copy/paste inside one statement
 * still works.
 */

import { EditorView } from '@codemirror/view';

import { dedentCode } from './dedent';

export function pasteDedentExtension() {
  return EditorView.domEventHandlers({
    paste(event, view) {
      const text = event.clipboardData?.getData('text/plain');
      if (!text || !text.includes('\n')) return false;

      const dedented = dedentCode(text);
      if (dedented === text) return false;

      event.preventDefault();

      const { from, to } = view.state.selection.main;
      view.dispatch({
        changes: { from, to, insert: dedented },
        selection: { anchor: from + dedented.length },
        scrollIntoView: true,
        userEvent: 'input.paste',
      });
      return true;
    },
  });
}
